export default __webpack_public_path__ + "static/media/white.1038c163.png";